// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationWebpageApi,
  ICertificationWebpageApiRequest,
  ICertificationWebpagePurposeOfAssessmentApiGetDetailAttrs,
  ICertificationWebpagePurposeOfAssessmentApiDetailResponse,
  ICertificationWebpagePurposeOfAssessmentApiGetListAttrs,
  ICertificationWebpagePurposeOfAssessmentApiListResponse,
  ICertificationWebpagePurposeOfAssessmentApiUpdateAttrs,
  ICertificationWebpagePurposeOfAssessmentCompetencyUnitApiGetListAttrs,
  ICertificationWebpagePurposeOfAssessmentCompetencyUnitApiListResponse,
} from 'interfaces/webpage/certification/registration/purpose-of-assessment/purpose-of-assessment-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class CertificationWebpagePurposeOfAssessmentApi
  extends BaseApi<ICertificationWebpageApi>
  implements ICertificationWebpageApiRequest
{
  readonly url = ApiConstantHc.CERTIFICATION_REGISTRATION_PURPOSE_OF_ASSESSMENTS_URL
  private certificationRegistrationPurposeOfAssessmentUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get certification purpose competency unit list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpagePurposeOfAssessmentCompetencyUnitApiGetListAttrs} payload
   *
   * @return {Promise<ICertificationWebpagePurposeOfAssessmentCompetencyUnitApiListResponse>} Promise<ICertificationPurposeOfAssessmentCompetencyUnitApiListResponse>
   */
  async certificationWebpagePurposeOfAssessment_getCompetencyUnitList(
    payload: ICertificationWebpagePurposeOfAssessmentCompetencyUnitApiGetListAttrs,
  ): Promise<ICertificationWebpagePurposeOfAssessmentCompetencyUnitApiListResponse> {
    return this.POST(
      `${this.certificationRegistrationPurposeOfAssessmentUrl}/competencyUnits/list/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Get certification purpose list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpagePurposeOfAssessmentApiGetListAttrs} payload
   *
   * @return {Promise<ICertificationWebpagePurposeOfAssessmentApiListResponse>} Promise<ICertificationWebpagePurposeOfAssessmentApiListResponse>
   */
  async certificationWebpagePurposeOfAssessment_getList(
    payload: ICertificationWebpagePurposeOfAssessmentApiGetListAttrs,
  ): Promise<ICertificationWebpagePurposeOfAssessmentApiListResponse> {
    return this.POST(`${this.certificationRegistrationPurposeOfAssessmentUrl}/list`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Get certification purpose detail
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpagePurposeOfAssessmentApiGetDetailAttrs} payload
   *
   * @return {Promise<ICertificationWebpagePurposeOfAssessmentApiDetailResponse>} Promise<ICertificationWebpagePurposeOfAssessmentApiDetailResponse>
   */
  async certificationWebpagePurposeOfAssessment_getDetail(
    payload: ICertificationWebpagePurposeOfAssessmentApiGetDetailAttrs,
  ): Promise<ICertificationWebpagePurposeOfAssessmentApiDetailResponse> {
    return this.POST(
      `${this.certificationRegistrationPurposeOfAssessmentUrl}/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Update certification purpose
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpagePurposeOfAssessmentApiUpdateAttrs} payload
   *
   * @return {Promise<ICertificationWebpagePurposeOfAssessmentApiDetailResponse>} Promise<ICertificationWebpagePurposeOfAssessmentApiDetailResponse>
   */
  async certificationWebpagePurposeOfAssessment_update(
    payload: ICertificationWebpagePurposeOfAssessmentApiUpdateAttrs,
  ): Promise<ICertificationWebpagePurposeOfAssessmentApiDetailResponse> {
    return this.POST(
      `${this.certificationRegistrationPurposeOfAssessmentUrl}/update/${payload.params.assessmentId}`,
      payload.body,
      { ...payload.requestConfig },
    )
  }
}
